export default "__VITE_ASSET__D5s16lrx__"